'use client';

import useGetLoginInfoQuery from '@module/helpers/auth/useGetLoginInfoQuery';
import useModalStore from '@module/stores/useModalStore';
import { useRouter } from 'next/navigation';
import type { ReactNode } from 'react';
import BaseButton from '../../BaseButton';

function OneToOneInquiryButton({ children }: { children: ReactNode }) {
  const router = useRouter();
  const { pushModal } = useModalStore();
  const { isLogin } = useGetLoginInfoQuery();
  return (
    <div className='mt-16 flex justify-center'>
      <BaseButton
        variant='primary'
        size='md'
        onClick={() => {
          if (!isLogin) {
            pushModal({
              type: 'AUTH_MODAL',
            });
            return;
          }
          router.push('/customer/inquire/write');
        }}
      >
        {children}
      </BaseButton>
    </div>
  );
}

export default OneToOneInquiryButton;
